"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberActivityWithoutAsideWeb = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const OfflineInfo_1 = __importDefault(require("../organisms/offline-mode/OfflineInfo"));
const MemberActivityWithoutAsideWeb = (props) => {
    if (props.isOffline) {
        return (0, jsx_runtime_1.jsx)(OfflineInfo_1.default, { translations: props.translations }, void 0);
    }
    return ((0, jsx_runtime_1.jsx)(ContainerRWDWithoutProgressBar, { children: props.children }, void 0));
};
exports.MemberActivityWithoutAsideWeb = MemberActivityWithoutAsideWeb;
const ContainerRWDWithoutProgressBar = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacings.m};

  @media (min-width: 1025px) and (max-width: 1300px) {
    //margin-top: 30px;
  }

  @media (max-width: 1024px) {
    justify-content: flex-start;
    padding: 0;
  }
`;
//# sourceMappingURL=MemberActivityWithoutAsideWeb.js.map